import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { authInterceptor } from './auth-interceptor';

export function AuthInject() {
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    authInterceptor.setAuthGetter(getAccessTokenSilently);
    return () => authInterceptor.setAuthGetter(undefined);
  }, [getAccessTokenSilently]);

  return null;
}
